
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';

export const metadata = {
  toc: true,
  subnav: true,
  maxTocLevel: 4,
  layout: 'reference',
  secondLevelToc: true,
  alwaysExpand: true,
  parentTocLevel: 3,
  childTocLevel: 4,
  description: 'API reference for Transfer endpoints and webhooks.',
  source: 'endpoint'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Header title='Transfer' subtitle='API reference for Transfer endpoints and webhooks' compact mdxType="Header" />
    <p>{`For how-to guidance, see the `}<a parentName="p" {...{
        "href": "/docs/transfer"
      }}>{`Transfer documentation`}</a>{`.`}</p>
    <div className="long-endpoint-table">
      <table>
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": null
            }}>{`Initiating Transfers`}</th>
            <th parentName="tr" {...{
              "align": null
            }}></th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`/transfer/authorization/create`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Create a transfer authorization`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`/transfer/authorization/cancel`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Cancel a transfer authorization`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`/transfer/create`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Create a transfer`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`/transfer/cancel`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Cancel a transfer`}</td>
          </tr>
        </tbody>
      </table>
      <table>
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": null
            }}>{`Reading Transfers`}</th>
            <th parentName="tr" {...{
              "align": null
            }}></th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`/transfer/get`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Retrieve information about a transfer`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`/transfer/list`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Retrieve a list of transfers and their statuses`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`/transfer/event/list`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Retrieve a list of transfer events`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`/transfer/event/sync`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Sync transfer events`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`/transfer/sweep/get`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Retrieve information about a sweep`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`/transfer/sweep/list`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Retrieve a list of sweeps`}</td>
          </tr>
        </tbody>
      </table>
      <table>
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": null
            }}>{`Account Linking`}</th>
            <th parentName="tr" {...{
              "align": null
            }}></th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`/transfer/capabilities/get`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Determine RTP and RfP eligibility for a Plaid Item`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`/transfer/intent/create`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Create a transfer intent and invoke Transfer UI (Transfer UI only)`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`/transfer/intent/get`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Retrieve information about a transfer intent (Transfer UI only)`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`/transfer/migrate_account`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Create an Item to use with Transfer from known account and routing numbers`}</td>
          </tr>
        </tbody>
      </table>
      <table>
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": null
            }}>{`Recurring Transfers`}</th>
            <th parentName="tr" {...{
              "align": null
            }}></th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`/transfer/recurring/create`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Create a recurring transfer`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`/transfer/recurring/cancel`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Cancel a recurring transfer`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`/transfer/recurring/get`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Retrieve information about a recurring transfer`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`/transfer/recurring/list`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Retrieve a list of recurring transfers`}</td>
          </tr>
        </tbody>
      </table>
      <table>
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": null
            }}>{`Refunds`}</th>
            <th parentName="tr" {...{
              "align": null
            }}></th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`/transfer/refund/create`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Create a refund for a transfer`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`/transfer/refund/cancel`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Cancel a refund`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`/transfer/refund/get`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Retrieve information about a refund`}</td>
          </tr>
        </tbody>
      </table>
      <table>
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": null
            }}>{`Transfer for Platforms`}</th>
            <th parentName="tr" {...{
              "align": null
            }}></th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`/transfer/platform/originator/create`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Pass transfer specific onboarding info for the originator`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`/transfer/platform/person/create`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Create each individual who is a beneficial owner or control person of the business`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`/transfer/platform/requirement/submit`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Pass additional data Plaid needs to make an onboarding decision for the originator`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`/transfer/platform/document/submit`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Submit documents Plaid needs to verify information about the originator`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`/transfer/originator/get`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Get the status of an originator's onboarding`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`/transfer/originator/list`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Get the status of all originators' onboarding`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`/transfer/originator/funding_account/create`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Create a new funding account for an originator`}</td>
          </tr>
        </tbody>
      </table>
      <table>
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": null
            }}>{`Plaid Ledger`}</th>
            <th parentName="tr" {...{
              "align": null
            }}></th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`/transfer/ledger/deposit`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Deposit funds into a ledger balance held with Plaid`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`/transfer/ledger/distribute`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Move available balance between platform and its originator`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`/transfer/ledger/get`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Retrieve information about the ledger balance held with Plaid`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`/transfer/ledger/withdraw`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Withdraw funds from a ledger balance held with Plaid`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`/transfer/ledger/event/list`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Retrieve a list of ledger balance events`}</td>
          </tr>
        </tbody>
      </table>
      <table>
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": null
            }}>{`Program Metrics`}</th>
            <th parentName="tr" {...{
              "align": null
            }}></th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`/transfer/metrics/get`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Get transfer product usage metrics`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`/transfer/configuration/get`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Get transfer product configuration`}</td>
          </tr>
        </tbody>
      </table>
      <table>
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": null
            }}>{`Sandbox`}</th>
            <th parentName="tr" {...{
              "align": null
            }}></th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`/sandbox/transfer/simulate`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Simulate a transfer event`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`/sandbox/transfer/refund/simulate`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Simulate a refund event`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`/sandbox/transfer/fire_webhook`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Simulate a transfer webhook`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`/sandbox/transfer/ledger/deposit/simulate`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Simulate a deposit sweep event`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`/sandbox/transfer/ledger/simulate_available`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Simulate converting pending balance into available balance`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`/sandbox/transfer/ledger/withdraw/simulate`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Simulate a withdrawal sweep event`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`/sandbox/transfer/test_clock/create`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Create a test clock`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`/sandbox/transfer/test_clock/advance`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Advance a test clock`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`/sandbox/transfer/test_clock/get`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Retrieve information about a test clock`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`/sandbox/transfer/test_clock/list`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Retrieve a list of test clocks`}</td>
          </tr>
        </tbody>
      </table>
      <table>
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": null
            }}>{`Webhooks`}</th>
            <th parentName="tr" {...{
              "align": null
            }}></th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><a parentName="td" {...{
                "href": "/docs/api/products/transfer/reading-transfers/#transfer_events_update"
              }}><inlineCode parentName="a">{`TRANSFER_EVENTS_UPDATE`}</inlineCode></a></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`New transfer events available`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><a parentName="td" {...{
                "href": "/docs/api/products/transfer/recurring-transfers/#recurring_cancelled"
              }}><inlineCode parentName="a">{`RECURRING_CANCELLED`}</inlineCode></a></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`A recurring transfer has been cancelled by Plaid`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><a parentName="td" {...{
                "href": "/docs/api/products/transfer/recurring-transfers/#recurring_new_transfer"
              }}><inlineCode parentName="a">{`RECURRING_NEW_TRANSFER`}</inlineCode></a></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`A new transfer of a recurring transfer has been originated`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><a parentName="td" {...{
                "href": "/docs/api/products/transfer/recurring-transfers/#recurring_transfer_skipped"
              }}><inlineCode parentName="a">{`RECURRING_TRANSFER_SKIPPED`}</inlineCode></a></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`An instance of a scheduled recurring transfer could not be created`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><a parentName="td" {...{
                "href": "/docs/api/products/transfer/platform-payments/#platform_onboarding_update"
              }}><inlineCode parentName="a">{`PLATFORM_ONBOARDING_UPDATE`}</inlineCode></a></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The status of an onboarding originator has been updated`}</td>
          </tr>
        </tbody>
      </table>
    </div>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
